import { defineComponent as _defineComponent } from 'vue';
import { defineComponent, ref } from 'vue';
import { useClickOutside, useFocusEvents } from '@/shared/lib';
import { NavButton } from '@/shared/ui';
import ContactsContent from './ContactsContent.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ContactsButton',
  setup: function setup(__props) {
    defineComponent({
      name: 'ContactsButton'
    });
    var contactsContentOpen = ref(false);
    var rootRef = ref(null);
    function handleContacts() {
      contactsContentOpen.value = !contactsContentOpen.value;
    }
    useClickOutside(rootRef, function () {
      contactsContentOpen.value = false;
    });
    useFocusEvents(rootRef, {
      onFocusOutside: function onFocusOutside() {
        contactsContentOpen.value = false;
      }
    });
    return {
      __sfc: true,
      contactsContentOpen: contactsContentOpen,
      rootRef: rootRef,
      handleContacts: handleContacts,
      NavButton: NavButton,
      ContactsContent: ContactsContent
    };
  }
});